import {GET_CREDITCARDS} from '../actions/credit_card/type';

const initState = {cards: []};
export default function(state = initState, action) {
    switch (action.type) {
        case GET_CREDITCARDS:
            return {...state, cards: action.payload};
        default:
            return state;
    }
}